module.exports = __webpack_public_path__ + "img/data-center04.2a82b5ee.png";